"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("quill/dist/quill.core.css");
require("quill/dist/quill.snow.css");
require("quill/dist/quill.bubble.css");
var _vueQuillEditor = require("vue-quill-editor");
var _default = exports.default = {
  name: 'wl-rich-text',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      default: false
    },
    readonly: {
      default: false
    },
    height: {
      type: [Number, String],
      default: '200px'
    }
  },
  components: {
    quillEditor: _vueQuillEditor.quillEditor
  },
  data: function data() {
    return {
      richTextValue: ''
    };
  },
  watch: {
    richTextValue: {
      handler: function handler(nv, ov) {
        this.$emit('input', nv);
        this.$emit('change', nv, ov);
      },
      deep: true
    },
    value: {
      handler: function handler(nv) {
        this.richTextValue = nv;
      },
      deep: true
    }
  },
  methods: {},
  created: function created() {
    var _this = this;
    this.richTextValue = this.value;
    this.$nextTick(function () {
      var _a$$refs$editor;
      var a = _this.$refs.myQuillEditor;
      var b = _this.$refs.myQuillEditorInput;
      if (!a || !b) return;
      var c = a === null || a === void 0 || (_a$$refs$editor = a.$refs.editor) === null || _a$$refs$editor === void 0 ? void 0 : _a$$refs$editor.querySelector('.ql-editor');
      c.onblur = function () {
        var _b$$el, _b$$el2;
        (_b$$el = b.$el) === null || _b$$el === void 0 || _b$$el.querySelector('input').focus();
        (_b$$el2 = b.$el) === null || _b$$el2 === void 0 || _b$$el2.querySelector('input').blur();
      };
    });
  },
  mounted: function mounted() {},
  updated: function updated() {
    var _this$$refs$myQuillEd, _parseInt, _this$height$replace;
    var a = (_this$$refs$myQuillEd = this.$refs.myQuillEditor) === null || _this$$refs$myQuillEd === void 0 ? void 0 : _this$$refs$myQuillEd.$el.querySelector('.ql-editor');
    var b = a ? this.$$getOriginalStyle(a, ['padding-top', 'padding-bottom']) : '';
    var h = (_parseInt = parseInt(this.height, 10)) !== null && _parseInt !== void 0 ? _parseInt : 0;
    var d = (_this$height$replace = this.height.replace(/[0-9]+/g, '')) !== null && _this$height$replace !== void 0 ? _this$height$replace : 'px';
    var c = 0;
    b.forEach(function (s) {
      c += parseInt(s, 10);
    });
    a.style.cssText += ";height: ".concat(c + h).concat(d, ";");
  }
};